import React from 'react';
import { Activity, Briefcase, DollarSign, GitBranch, Users2 } from 'lucide-react';
import { RibbonDesktopButton } from '../ribbon/DesktopRibbonControls';
import type { OpsScreen } from '../../hooks/useOperationsCenterRibbon';

interface OpsScreenModeTabsProps {
  screen: OpsScreen;
  onChange: (screen: OpsScreen) => void;
}

const MODES: Array<{ id: OpsScreen; label: string; icon: React.ReactNode }> = [
  { id: 'live', label: 'Ao Vivo', icon: <Activity size={18} strokeWidth={1.5} /> },
  { id: 'capacity', label: 'Capacidade', icon: <Users2 size={18} strokeWidth={1.5} /> },
  { id: 'flow', label: 'Fluxo', icon: <GitBranch size={18} strokeWidth={1.5} /> },
  { id: 'results', label: 'Resultados', icon: <DollarSign size={18} strokeWidth={1.5} /> },
  { id: 'executive', label: 'Executivo', icon: <Briefcase size={18} strokeWidth={1.5} /> },
];

export const OpsScreenModeTabs: React.FC<OpsScreenModeTabsProps> = ({
  screen,
  onChange,
}) => (
  <div
    className="flex h-full max-w-full shrink-0 items-center gap-0.5 overflow-x-auto pr-2 scrollbar-none"
    style={{
      borderRight: '1px solid var(--border-default, rgba(255,255,255,0.08))',
      marginRight: '4px',
    }}
  >
    {MODES.map((mode) => (
      <RibbonDesktopButton
        key={mode.id}
        icon={mode.icon}
        label={mode.label}
        active={screen === mode.id}
        onClick={() => onChange(mode.id)}
        title={mode.label}
      />
    ))}
  </div>
);

export default OpsScreenModeTabs;
